import api from "@/services/api";

export default {
  login(username, password) {
    return api.post("/auth/login/", { username, password });
  },
  logout() {
    return api.post("/auth/logout/", {});
  },
  register(firstName, lastName, postalCode, isStakeholder, email) {
    return api.post("/auth/registration/", {
      firstName,
      lastName,
      postalCode,
      isStakeholder,
      email
    });
  },
  resetPassword(email) {
    return api.post("/auth/password/reset/", { email });
  },
  resetPasswordConfirm(newPassword1, newPassword2, uid, token) {
    return api.post("/auth/password/reset/" + uid + "/" + token + "/", {
      newPassword1,
      newPassword2,
      uid,
      token
    });
  },
  passwordChange(newPassword1, newPassword2) {
    return api.post("/auth/password/change/", { newPassword1, newPassword2 });
  },
  confirmEmail(key) {
    // Example of this would be something like this:
    // http://localhost:8000/auth/verify-email/NDA:1hsoNf:RtDYmLjAZIb0Ihz05oRGCKj-GOs/
    return api.post("/auth/verify-email/" + key + "/", { key });
  }
  // createAccount(username, password1, password2, email) {
  //   return api.post('/registration/', { username, password1, password2, email });
  // },
  // changeAccountPassword(password1, password2) {
  //   return api.post('/auth/password/change/', { password1, password2 });
  // },
  // sendAccountPasswordResetEmail(email) {
  //   return api.post('/auth/password/reset/', { email });
  // },
  // resetAccountPassword(uid, token, new_password1, new_password2) { // eslint-disable-line camelcase
  //   return api.post('/auth/password/reset/confirm/', { uid, token, new_password1, new_password2 });
  // },
  // getAccountDetails() {
  //   return api.get('/auth/user/');
  // },
  // updateAccountDetails(data) {
  //   return api.patch('/auth/user/', data);
  // },
  // verifyAccountEmail(key) {
  //   return api.post('/registration/verify-email/', { key });
  // },
};
